module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/255-brazil-a0db036ce393001527ec7e02b7258931.svg";